import { render, staticRenderFns } from "./vis-page-recovery.vue?vue&type=template&id=41c1207d"
import script from "./vis-page-recovery.vue?vue&type=script&lang=js"
export * from "./vis-page-recovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports